import { render } from "./Index.vue?vue&type=template&id=67ea1d0d&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=67ea1d0d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-67ea1d0d"

export default script